var map = {
	"./customer-bg.webp": 1507,
	"./customer-img.webp": 1508,
	"./dice-img.webp": 1509,
	"./games-img.webp": 1510,
	"./lc-img.webp": 1511,
	"./lottery-img.webp": 1512,
	"./mission-bg.webp": 1513,
	"./mission-img-2.webp": 1514,
	"./mission-img.webp": 1515,
	"./mission-main-bg.webp": 1516,
	"./mobile-bg.webp": 1517,
	"./p2p-img.webp": 1518,
	"./product-bg.webp": 1519,
	"./product-main-bg.webp": 1520,
	"./sb-provider.webp": 1521,
	"./sbo-provider.webp": 1522,
	"./side-bar-bg.webp": 1523,
	"./slot-img.webp": 1524,
	"./spade-img.webp": 1525,
	"./sport-img.webp": 1526
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;